import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-260">
      <HeroSection data-id="element-261" />

      <SignalSection data-id="element-262" />

      <ProtocolSection data-id="element-263" />

      <BenefitsSection data-id="element-264" />
      <PainSection data-id="element-265" />

      <TestimonialsSection data-id="element-266" />

      <DifferenceSection data-id="element-267" />

      

      <ForWhoSection data-id="element-268" />

      <BibliotecaSection data-id="element-269" />

      <OfferSection data-id="element-270" />

      <AboutSection data-id="element-271" />

      <FAQSection data-id="element-272" />

      <FinalCTASection data-id="element-273" />
    </main>;
}